import { date } from "yup"

export interface CurrencyExchangeRateClass{
    AccountCurrencyExchangeRateId: number
    ExchangeRateEffectiveStartDate: Date
    ExchangeRateEffectiveEndDate: Date
    ExchangeRate:number
    AccountCurrencyId:number
    MasterAccountCurrencyExchangeRateId: number
    AccountCurrencyExchangeRateGuidId:string
    AccountId: number
    CreatedByEmployeeId: number
    CreatedOn: Date | undefined
    ModifiedByEmployeeId: number
    ModifiedOn: Date | undefined
    IsUpdateExpenseEntry:boolean
    isSelected:number
}
const common = {    
    AccountCurrencyExchangeRateId:0,
    ExchangeRateEffectiveStartDate: new Date(),
    ExchangeRateEffectiveEndDate: new Date(),
    ExchangeRate:0,
    AccountCurrencyId:0,
    MasterAccountCurrencyExchangeRateId: 0,
    AccountCurrencyExchangeRateGuidId:"",
    IsUpdateExpenseEntry:false
  };


export const CurrencyExchangeRateInitialsForAdd ={ ...common };

export const CurrencyExchangeRateInitialsForUpdate = {
    ...common
   
}






// export const CurrencyExchangeRateInitialsForAdd = {
//     AccountCurrencyExchangeRateId:0,
//     ExchangeRateEffectiveStartDate: new Date(),
//     ExchangeRateEffectiveEndDate: new Date(),
//     ExchangeRate:0,
//     AccountCurrencyId:0,
//     MasterAccountCurrencyExchangeRateId: 0,
//     AccountCurrencyExchangeRateGuidId:"",
//     IsUpdateExpenseEntry:false
    
// }

// export const CurrencyExchangeRateInitialsForUpdate = {
//     AccountCurrencyExchangeRateId:0,
//     ExchangeRateEffectiveStartDate: new Date(),
//     ExchangeRateEffectiveEndDate: new Date(),
//     ExchangeRate:0,
//     AccountCurrencyId:0,
//     MasterAccountCurrencyExchangeRateId: 0,
//     AccountCurrencyExchangeRateGuidId:"",
//     IsUpdateExpenseEntry:false

// }